import { Box } from '@mui/material';
import { NegationFilterPanel } from './NegationFilterPanel';

export const SearchFilterPanel = () => {
  return (
    <Box sx={{ minWidth: 850 }}>
      <NegationFilterPanel />
    </Box>
  );
};
